import { atom, getDefaultStore } from 'jotai';
import { ANALYTICS_ACTIONS, ANALYTICS_CATEGORIES, trackAnalyticsEvent } from '@src/utils/analyticsTracking';

const jotaiStore = getDefaultStore();

export const loginSubmittingAtom = atom(false);
export const loginErrorAtom = atom<string | null>(null);
export const loginLoggedAtom = atom<boolean | undefined>(undefined);

export function setLoginSubmitting(): void {
  trackAnalyticsEvent(ANALYTICS_ACTIONS.loginSubmitting, ANALYTICS_CATEGORIES.login);
  jotaiStore.set(loginSubmittingAtom, true);
  jotaiStore.set(loginErrorAtom, null);
}

export function setLoginSuccess(): void {
  jotaiStore.set(loginLoggedAtom, true);
  jotaiStore.set(loginSubmittingAtom, false);
}

export function setLoginFailed(error: string | null): void {
  trackAnalyticsEvent(ANALYTICS_ACTIONS.loginFailed, ANALYTICS_CATEGORIES.login);
  jotaiStore.set(loginErrorAtom, error);
  jotaiStore.set(loginSubmittingAtom, false);
  jotaiStore.set(loginLoggedAtom, false);
}

export function setLoggedOut(): void {
  trackAnalyticsEvent(ANALYTICS_ACTIONS.logout, ANALYTICS_CATEGORIES.login);
  jotaiStore.set(loginSubmittingAtom, false);
  jotaiStore.set(loginLoggedAtom, false);
}

export function clearLoginError(): void {
  jotaiStore.set(loginErrorAtom, null);
}
